module.exports = __webpack_public_path__ + "static/media/portfolio.d05cb063.jpg";